import nookies from "nookies";
import { AUTH_TOKEN_KEY } from "../utils/constDictionary";
import encodedURIQueryStringConverter from "../utils/encodedURIQueryStringConverter";
import { getClientCustomFetch } from "../lib/getClientCustomFetch";

const headersWithAuthToken = (authToken) => {
  const obj = {
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
  };
  return obj;
};

// NOTE: The argument `context` is optional and must be passed for server side data fetch
const headers = (context) => {
  const { [AUTH_TOKEN_KEY]: authToken } = nookies.get(context);
  return headersWithAuthToken(authToken);
};

const getOrderDetails = async (referenceNumber, params) => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.get(
    encodedURIQueryStringConverter(`/order/${referenceNumber}`, { ...params })
  );
  return resp;
};

const getInvoice = async (referenceNumber, options) => {
  const customFetch = await getClientCustomFetch();
  const { baseURL = "public" } = options;
  const resp = await customFetch.get(
    `${baseURL}/public/invoice?orderId=${referenceNumber}`
  );
  return resp;
};

const getOrderInvoice = async (referenceNumber) => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.get(`/invoice/${referenceNumber}`);
  return resp;
};

const getOrder = async (options, queryParams = {}) => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.get(
    encodedURIQueryStringConverter("/order", { ...queryParams }),
    options
  );
  return resp?.data;
};

const cancelOrder = async (referenceNumber, params) => {
  const customFetch = await getClientCustomFetch();
  const resp = customFetch.delete(`/order/${referenceNumber}`, {
    ...params,
  });
  return resp;
};

const getMyProducts = async (params) => {
  const customFetch = await getClientCustomFetch();
  const { storeId = "" } = params;
  const resp = await customFetch.get(
    encodedURIQueryStringConverter(`/my-product`, {
      ...params,
    })
  );
  return resp?.data;
};

const getOrderLiveTracking = async (referenceNumber) => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.get(
    `/order-location?orderId=${referenceNumber}`
  );
  return resp?.data;
};

const getOrderDisputeReasons = async () => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.get("/dispute-reason");
  return resp;
};

const postOrderReturnForm = async (referenceNumber, data) => {
  const customFetch = await getClientCustomFetch();
  const resp = await customFetch.post(`/order/${referenceNumber}/dispute`, {
    items: data,
  });
  return resp?.data;
};

export {
  getOrderDetails,
  getOrder,
  cancelOrder,
  headers,
  getMyProducts,
  getInvoice,
  getOrderLiveTracking,
  getOrderInvoice,
  getOrderDisputeReasons,
  postOrderReturnForm,
};
